import React from 'react'
import { Loading } from "../../../redux/action";
import { connect } from "react-redux";
import "./brand-data.scss";
import { DefaultAccountLogo, DefaultUserProfile } from "../../../config/config";
import { Link } from 'react-router-dom';
import MaterialSymbol from '../../../components/icons/material-symbol';
import { Tooltip } from '@mui/material';

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  topPaidInfluencer: any;
  topCompetitors: any;
  topOrganicInfluencer:any;
}

const TopInfluencer: React.FC<Props> = (props: Props) => {
  return (

    <div className="brand-insight-influencer-competitor">
      {props?.topPaidInfluencer.length > 0 &&
        <div className="brand-insight-influencer-competitor-row">
          <strong>
            <div className='d-flex align-items-center'>
            Top Paid Influencers 
              <Tooltip title="These influencers have participated in verified paid brand collaborations through the platform." arrow placement='top'>
                <span className='ms-1 align-self-center' style={{lineHeight:0}}>
                  <MaterialSymbol iconName='info' fontweight='200' fontSize='18px' />
                </span>
              </Tooltip>
            </div>
            
          </strong>
          <ul>
            {props?.topPaidInfluencer.slice(0, 10).map((influencer: any) => (
              <li>
                <img
                  src={influencer?.gcp_display_url.length > 0 ? influencer?.gcp_display_url : DefaultUserProfile.influencer_unknown_default}
                  alt={influencer.username}
                  className="avatar"
                  width={40}
                  height={40}
                  style={{ borderRadius: '50%', fontSize: '5px' }}
                />
              </li>
            ))}
          </ul>
        </div>
      }
      {props?.topOrganicInfluencer.length > 0 &&
        <div className="brand-insight-influencer-competitor-row">
          <strong>
            <div className='d-flex align-items-center'>
            Top Organic Influencers
              <Tooltip title="These influencers have collaborated with brands, but the collaboration isn't confirmed as paid." arrow placement='top'>
                <span className='ms-1 align-self-center' style={{lineHeight:0}}>
                  <MaterialSymbol iconName='info' fontweight='200' fontSize='18px' />
                </span>
              </Tooltip>
            </div>
            
          </strong>
          <ul>
            {props?.topOrganicInfluencer.slice(0, 6).map((influencer: any) => (
              <li>
                <img
                  src={influencer.gcp_profile_pic_url.length > 0 ? influencer.gcp_profile_pic_url : DefaultUserProfile.influencer_unknown_default}
                  alt={influencer.username}
                  className="avatar"
                  width={40}
                  height={40}
                  style={{ borderRadius: '50%', fontSize: '5px' }}
                />
              </li>
            ))}
          </ul>
        </div>
      }
      {props.topCompetitors.length > 0 &&
        <div className="brand-insight-influencer-competitor-row">
          <strong>
            Top Competitors
            
          </strong>
          <div className='d-flex'>
            <ul>
              {Array.from({ length: 10 }).map((_, index) => {
                const competitor = props.topCompetitors[index];
                return (
                  <li key={index} className="position-relative">
                    {competitor ? (
                      <>
                        <img
                          src={competitor.gcp_profile_image_url}
                          alt={competitor.insta_name}
                          className="avatar"
                          width={40}
                          height={40}
                          style={{ borderRadius: '50%' }}
                        />
                        <span className="brand-insight-influencer-close">
                          <MaterialSymbol iconName="close" fontweight="200" />
                        </span>
                      </>
                    ) : (
                      <span className="brand-insight-influencer-add">
                        <MaterialSymbol iconName="add" fontweight="200" />
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      }
    </div>
  )
}

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(TopInfluencer);

export { connectToRedux as TopInfluencer };

